/* eslint-disable */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PageNotFound() {
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      navigate(-1); // simulate going back
    }, 1000);
  });
  return (<h1>Page Not Found!</h1>);
}
